export default "__VITE_ASSET__9182b5fc__"